import ClipIcon from '@components/icons/Clip.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { ToolbarActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/ToolbarActionButton';

export const AttachBackupButton = ({
  workspaceId,
  id,
  reload,
}: {
  workspaceId: string;
  id: string;
  reload: () => void;
}) => {
  const { openModal, closeModal } = useModalContext();
  const { organization } = useAuthContext();

  const showBackupFilesModal = () => {
    openModal(ModalNamesEnum.BackupFilesModal, {
      onSuccess: () => {
        closeModal();
        reload();
      },
      id,
      workspaceId,
    });
  };

  const canSubmitJobs = organization?.permissions?.submitJobs;
  if (!id || !canSubmitJobs) {
    return null;
  }

  return (
    <ToolbarActionButton type="button" title="Check Backup Files" onClick={showBackupFilesModal}>
      <ClipIcon className="!h-[24px] !w-[24px]" />
      Check Backup Files
    </ToolbarActionButton>
  );
};
